import { A } from "@solidjs/router";
import type { FlowsView } from "../../enums/scan";
import { mapPreviewHref } from "../map/MapScanNavigation";
import { FlowsViewToggle } from "./FlowsViewToggle";

export function FlowsModeBar(props: {
  websiteId: string;
  view: FlowsView;
  onChange: (view: FlowsView) => void;
  returnQuery: string;
}) {
  return (
    <section class="flows-mode-bar" aria-label="Flows view">
      <FlowsViewToggle view={props.view} onChange={props.onChange} />
      <div class="flows-map-route">
        <p id="flows-map-description">
          Explore draft recommendations for the content structure.
          <br />
          Uses this website's whole scanned estate, across all pages and paths.
        </p>
        <A
          class="scan-btn"
          href={mapPreviewHref(props.websiteId, props.returnQuery)}
          aria-describedby="flows-map-description"
        >
          Explore Signal Map Preview
        </A>
      </div>
    </section>
  );
}
